import {ContentsType} from './constants';
import {contentsRuleDefaults} from './defaults';
import {ContentsRule} from './types';

type GetContentsRuleParams<T extends ContentsType = ContentsType> = {
	type?: T;
	contents: string;
};

export const createContentsRule = ({
	contents,
	type,
}: GetContentsRuleParams): ContentsRule => ({
	...contentsRuleDefaults,
	elementSubType1: type != null ? type : contentsRuleDefaults.elementSubType1,
	elementValue1: contents,
});

export default createContentsRule;
